export const adjustMinValue = (minValue: number): number => {
  if (minValue === 0) return 0;

  const magnitude = 10 ** Math.floor(Math.log10(minValue));
  const adjustedMin = Math.floor(minValue / magnitude) * magnitude;
  // adjustedMin -= magnitude * 0.01; // Further adjustment for spacing
  return Math.floor(adjustedMin);
};

export const adjustMaxValue = (maxValue: number): number => {
  const magnitude = 10 ** Math.floor(Math.log10(maxValue));
  const adjustedMax = Math.ceil(maxValue / magnitude) * magnitude;
  // adjustedMax += magnitude * 0.01; // Extra space at the top
  return Math.ceil(adjustedMax);
};
